import React, { createContext } from 'react';
import { useAuthHelper } from '../../components/AuthContextProvider';
import * as UserManager from '../domain/user-manager';
import { Data } from '../../types';
import { dataFromDataset, useData } from './DataProviderCache';

type ContextState = Data<
    Array<{
        roleId: string;
        roleName: string;
    }>
>;
export const Context = createContext<ContextState | null>(null);

function useRegistrationRolesData(): ContextState {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useRegistrationRolesData must be used within a RegistrationRoleProvider');
    }
    return contextState;
}
const RegistrationRoleProvider: React.FC<{ userId: string; siteId: string }> = (props) => {
    const authHelper = useAuthHelper();
    const { dataset } = useData({
        cacheKey: 'registartion-role',
        id: props.userId,
        dataFn: React.useCallback(() => UserManager.getRegistrationRoles(authHelper, props.userId, props.siteId), [
            authHelper,
            props.userId,
            props.siteId,
        ]),
    });
    const registartionRoles = dataFromDataset(dataset);

    return <Context.Provider value={registartionRoles}>{props.children}</Context.Provider>;
};
const TestRegistrationRoleDataProvider: React.FC<{
    value: ContextState;
}> = (props) => <Context.Provider value={props.value}>{props.children}</Context.Provider>;

export { RegistrationRoleProvider, TestRegistrationRoleDataProvider, useRegistrationRolesData };
